const CUSTOMER_SUPPORT_PREFIX = '/customer-support';
const AUTHORIZED_ROUTES_PREFIX = '/auth';
const VM_PREFIX = '/vm';
const TRANSFER_PREFIX = '/transfer';
const USER_PREFIX = '/user';

/**
 * Configuration for local environment.
 */
const local = {
  api: {
    API_BASE_URL: 'http://localhost:5000',
  },
  msal: {
    CLIENT_ID: 'bf590d28-f557-4c12-85b5-24c788b41448',
    API_SCOPE_ID: '89cbca32-6637-4854-8ebc-0fb3323ee19b',
    REDIRECT_URI: '/login',
    POST_LOGOUT_REDIRECT_URI: '/',
  },
};

/**
 * Configuration for the development environment.
 */
const development = {
  api: {
    API_BASE_URL: 'https://daaas-portal-api.dev.cloud.statcan.ca',
    API_BASE_URL_RELEASE:
      'https://daaas-portal-api-release.dev.cloud.statcan.ca',
  },
  msal: {
    CLIENT_ID: 'bf590d28-f557-4c12-85b5-24c788b41448',
    API_SCOPE_ID: '89cbca32-6637-4854-8ebc-0fb3323ee19b',
    REDIRECT_URI: '/login',
    POST_LOGOUT_REDIRECT_URI: '/',
  },
};

/**
 * Configuration for the test environment.
 */
const test = {
  api: {
    API_BASE_URL: 'https://daaas-portal-api.test.cloud.statcan.ca',
    API_BASE_URL_RELEASE:
      'https://daaas-portal-api-release.test.cloud.statcan.ca',
  },
  msal: {
    CLIENT_ID: '93d46da8-7124-4293-8085-df51f501ec68',
    API_SCOPE_ID: '7358a15b-4539-4ec1-9ceb-2f049eb93d36',
    REDIRECT_URI: '/login',
    POST_LOGOUT_REDIRECT_URI: '/',
  },
};

/**
 * Configuration for the production environment.
 */
const production = {
  api: {
    API_BASE_URL: 'https://daaas-portal-api.prod.cloud.statcan.ca',
    API_BASE_URL_RELEASE:
      'https://www.statcan.gc.ca/data-analytics-services/api',
  },
  msal: {
    CLIENT_ID: '944be32b-f9c2-4732-9b78-9d39aa188746',
    API_SCOPE_ID: 'fd05b2f3-6ab0-46da-97d2-c83b28f43595',
    REDIRECT_URI: '/data-analytics-services/login',
    POST_LOGOUT_REDIRECT_URI: '/data-analytics-services/',
  },
};

// Portal environment variable encodes the environment and also the release channel
const environment = process.env.PORTAL_ENV || 'Local-development';

const envConfiguration = () => {
  let environmentConfig = development;

  const split = environment.split('-');
  const env = split[0];
  const channel = split[1];

  if (env === 'Production') {
    environmentConfig = production;
  } else if (env === 'Test') {
    environmentConfig = test;
  } else if (env === 'Development') {
    environmentConfig = development;
  } else if (env === 'Local') {
    environmentConfig = local;
  } else {
    environmentConfig = local;
  }

  // Set the base URL to the appropriate RELEASE value if we're in the release channel.
  if (channel === 'release') {
    environmentConfig.api.API_BASE_URL =
      environmentConfig.api.API_BASE_URL_RELEASE;
  }

  return environmentConfig;
};

const envConfig = envConfiguration();

const { API_BASE_URL } = envConfig.api;

const config = {
  api: {
    API_PROVIDE_FEEDBACK: `${API_BASE_URL}${CUSTOMER_SUPPORT_PREFIX}/provide-feedback`,
    API_CONTACT_SUPPORT: `${API_BASE_URL}${CUSTOMER_SUPPORT_PREFIX}/contact-support`,

    API_REQUEST_NAMESPACE: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}/request-namespace`,
    API_PASSWORD_RESET: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}/password-reset`,

    API_BASTION_CREATE: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/createbastionlink`,
    API_BASTION_DELETE: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/deletebastionlink`,
    API_BASTION_GET: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/getbastionlink`,

    API_VM_START: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/start`,
    API_VM_STOP: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/stop`,
    API_VM_STATUS: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/status`,
    API_VM_LIST: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/list`,
    API_VM_SHUTDOWN_SETTINGS: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/shutdown-settings`,
    API_VM_GET_SHUTDOWN_SETTINGS: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${VM_PREFIX}/get-shutdown-settings`,

    API_VDL_VETTED_FILES_LIST: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${TRANSFER_PREFIX}/blob/list`,
    API_VDL_VETTED_FILE_UPLOAD: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${TRANSFER_PREFIX}/blob/upload`,
    API_VDL_VETTED_FILE_DOWNLOAD: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${TRANSFER_PREFIX}/blob/download`,
    API_VDL_VETTED_FILE_DELETE: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${TRANSFER_PREFIX}/blob/delete`,
    API_VDL_CONTAINER_LIST: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${TRANSFER_PREFIX}/container/list`,

    API_USER_CHECK_MEMBER_GROUPS: `${API_BASE_URL}${AUTHORIZED_ROUTES_PREFIX}${USER_PREFIX}/check-member-groups`,
  },
  msal: {
    AUTHORITY:
      'https://login.microsoftonline.com/258f1f99-ee3d-42c7-bfc5-7af1b2343e02',
    ...envConfig.msal,
    TOKEN_DEFAULT_SCOPE: `api://${envConfig.msal.API_SCOPE_ID}/API.Access`,
  },
};

export { API_BASE_URL, config };
